import React from "react";
import ClubDetailPageComponent from "../components/club-detail/ClubDetailPageComponent";

export default function ClubDetailPage() {
  return <ClubDetailPageComponent />;
}
